"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M4.5 6.472C4.5 5.659 5.159 5 5.971 5h.211a1.26 1.26 0 0 0 1.26-1.26c0-.695.564-1.26 1.26-1.26h8.596c.696 0 1.26.565 1.26 1.26S19.122 5 19.818 5h.21c.813 0 1.472.66 1.472 1.472V19.9a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.19 7.75V19a2.6 2.6 0 0 0 2.6 2.6h10.415a2.6 2.6 0 0 0 2.6-2.6V7.75a2.6 2.6 0 0 0-2.6-2.6v-1.4a4 4 0 0 1 4 4V19a4 4 0 0 1-4 4H7.79a4 4 0 0 1-4-4V7.75a4 4 0 0 1 4-4v1.4a2.6 2.6 0 0 0-2.6 2.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.542 4.57A2.57 2.57 0 0 1 9.112 2h7.77a2.57 2.57 0 1 1 0 5.14h-7.77a2.57 2.57 0 0 1-2.57-2.57m2.57-1.17a1.17 1.17 0 1 0 0 2.34h7.77a1.17 1.17 0 1 0 0-2.34zm-.842 7.102a.7.7 0 0 1 .7-.7h8.056a.7.7 0 0 1 0 1.4H8.969a.7.7 0 0 1-.7-.7m0 3.473a.7.7 0 0 1 .7-.7h6.042a.7.7 0 1 1 0 1.4H8.969a.7.7 0 0 1-.7-.7m0 3.474a.7.7 0 0 1 .7-.7h8.056a.7.7 0 1 1 0 1.4H8.969a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FormsIcon26.js.map